import {Arg, BasicArg} from "../arg";
import {ClauseType, CommandClause} from "../../command";
import {PsdkConst} from "../../types";

/**
 * Easy argument abstract class
 */
export abstract class EasyArg<T> extends BasicArg<T> {
  private readonly prependClauses: Array<CommandClause>;
  private readonly appendClauses: Array<CommandClause>;

  public constructor() {
    super();
    this.prependClauses = [];
    this.appendClauses = [];
  }

  /**
   * Append another argument for this clause
   * @param arg
   */
  append(arg: Arg<T>): EasyArg<T> {
    this.appendClauses.push(...arg.clauses());
    return this;
  }

  /**
   * Prepend another argument for this clause
   * @param arg
   */
  prepend(arg: Arg<T>): EasyArg<T> {
    this.prependClauses.push(...arg.clauses());
    return this;
  }

  /**
   * Get current command clauses
   */
  clauses(): Array<CommandClause> {
    const clause = this.clause();
    const currentClauses = [];
    if (clause.type !== ClauseType.NONE) {
      currentClauses.push(clause);
      if (this.newline()) {
        currentClauses.push(CommandClause.newline());
      }
    }
    return [
      ...this.prependClauses,
      ...currentClauses,
      ...this.appendClauses,
    ];
  }

  clear() {
    this.prependClauses.splice(0, this.prependClauses.length);
    this.appendClauses.splice(0, this.appendClauses.length);
  }
}


export abstract class OnlyBinaryHeaderArg<T extends OnlyBinaryHeaderArg<any>> extends EasyArg<Uint8Array> {
  append(arg: Arg<Uint8Array>): T {
    super.append(arg);
    return this as unknown as T;
  }

  prepend(arg: Arg<Uint8Array>): T {
    super.prepend(arg);
    return this as unknown as T;
  }

  clause(): CommandClause {
    return CommandClause.binary(this.header());
  }

  newline(): boolean {
    return false;
  }
}

export abstract class OnlyTextHeaderArg<T extends OnlyTextHeaderArg<any>> extends EasyArg<string> {
  append(arg: Arg<string>): T {
    super.append(arg);
    return this as unknown as T;
  }

  prepend(arg: Arg<string>): T {
    super.prepend(arg);
    return this as unknown as T;
  }

  clause(): CommandClause {
    return CommandClause.text(this.header());
  }
}


